import { entitySegment, findBySegment } from './entityLink.js';

// URL-facing name as links were written before they carried the id; dashboard tab links still use it.
export const slugify = (name) => String(name || '').trim().toLowerCase().replace(/\s+/g, '-');

// A game's link segment: its name and its id ("space-race-17984202"). The id is what opens the game.
export const gameSlug = (game) => entitySegment(game?.gameName, game?.id);

// The game a link segment names: by its id, else (a link from before ids) the first game with that old name link.
export const findGameBySlug = (games, slug) => findBySegment(games, slug, (g) => slugify(g?.gameName));
